class AddFreeGift {
    constructor() {
      // this.init();
    }
  
    addProduct = async (productData) => {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ "items": productData })
        })
        const data = await response.json();
      } catch (error) {
        console.error('Error adding product:', error);
      }
    }
    removeItem = async (items) => {
      if (items.length > 0) {
        let item = items.pop();
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(item)
          })
          const data = await response.json();
          if (items.length > 0) {
            this.removeItem(items)
          }
        } catch (error) {
          console.error('Error adding product:', error);
        }
      }
    }
  
    freeGiftUpdate = async (cart) => {
      let total_price = Number(cart.total_price);
      let items = window.freeGifts;
      let changed = false;
      let addItems = []
      let removeItems = []
  
     
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
         
        let exist = cart.items.find((lineItem) => lineItem.variant_id == item.id && lineItem.properties['_free_gift'] == true);
        if(exist){
            total_price = total_price - exist.line_price;
        }
        if (!exist && total_price >= (item.price * 100)) {
          changed = true
          addItems.push({
            'id': item.id,
            'quantity': 1,
            'properties': { "_free_gift": true }
          })
        } else if (exist && total_price < (item.price * 100) ) {
          changed = true
          removeItems.push({
            'id': exist.key,
            'quantity': 0
          })
        }
  
      }
      console.log("addItems", addItems)
      console.log("removeItems", removeItems)
  
      if (addItems.length > 0) {
        let alreadyAppliedDiscount  = document.querySelector('.docapp-coupon-input--bean-container--bean-remove');
        if(alreadyAppliedDiscount){
            alreadyAppliedDiscount.click();
        }
        await this.addProduct(addItems)
      }
      if (removeItems.length > 0) {
        await this.removeItem(removeItems)
      }
      return changed
    }
  
    init = async (cart) => {
      if (!window.freeGiftLoading) {
        window.freeGiftLoading = true
        try {
        //   const res = await fetch('/cart.json');
        //   const cart = await res.json();
          const update = await this.freeGiftUpdate(cart);
          window.freeGiftLoading = false;
          if(value){
            let cartNotification = document.querySelector('cart-notification');
            if(cartNotification){
                // cartNotification.renderContents();
            }
          }
          if(update){
                window.upcartRefreshCart()
            }
          return update;
        } catch (e) {
          window.freeGiftLoading = false
          return false;
        }
      }
    }
  }
  window.freeGiftLoading = false;
  window.freeGiftPromo = new AddFreeGift();
  
//   window.freeGiftPromo.init();
  window.upcartModifyCart = (cart) => {
    // debugger;
    console.log("upcartModifyCart",cart);
    let update = window.freeGiftPromo.init(cart);
    var itemCount = cart.item_count;
    var itemsCount = document.querySelectorAll('#cart-notification-count');
    itemsCount.forEach((item)=>{
        if(itemCount <= 0){
            item.style.display = 'none';
        }else{
            item.style.display = 'flex';
            item.innerHTML = itemCount;
        }
    })
    let foundWhatsup = false;
    let applyDiscountText = document.querySelector('.whatsup-discount-apply');
    cart.items.forEach((line_item)=>{
        for(let i=0;i<line_item.discounts.length;i++){
            if(line_item.discounts[i].title == "WHATSUP"){
                foundWhatsup = true;
            }
        }
    }) 
    if(foundWhatsup){
        if(applyDiscountText){
            applyDiscountText.style.display = 'none';
        }
    }else{
        if(applyDiscountText){
            applyDiscountText.style.display = 'block';
        }
    }
 };

 document.addEventListener('click',(e)=>{
    if(e.target.classList.contains('whatsup-discount-apply-text')){
        let discountInput = document.querySelector('.upcart-discount-code-input')
        let discountapplyBtn = document.querySelector('.upcart-discount-code-button')
        if(discountInput){  
            let newValue = "WHATSUP";
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype,
                'value'
              ).set;
              nativeInputValueSetter.call(discountInput, newValue);
            
              // Create a synthetic event
              const event = new Event('input', { bubbles: true });
              
              // Dispatch the event
              discountInput.dispatchEvent(event);
            if(discountapplyBtn){
                setTimeout(() => {
                    discountapplyBtn.click();
                    // Log the value after clicking the button
                    console.log('Input value after button click:', discountInput.value);
                }, 100);
    
            }
        }
    }
 })